type MaxBusinessApiResponse = {
    error: boolean
    data: boolean | string
}

export function mapMaxBusinessStatus(response: MaxBusinessApiResponse) {
    if (response.error) {
        return {
            isConnected: false,
            status: 'error',
            message:
                typeof response.data === 'string'
                    ? response.data
                    : 'MAX Business connection error',
        }
    }

    return {
        isConnected: response.data === true,
        status: response.data === true ? 'authorized' : 'waiting',
        message: '',
    }
}

/** Same rule as ChannelSettingsForm / fetchChannelQrCode. */
export function isMaxBusinessStatusAuthorized(statusResponse: {
    data?: any
    error?: any
} | null): boolean {
    if (!statusResponse || statusResponse.error) return false
    const payload = statusResponse.data
    return payload?.error === false && payload?.data === true
}
